export enum EShipmentStages {
    Origin = "Origin",
    "In Transit" = "In Transit",
    Destination = "Destination",
    Completed = "Completed",
}
